import { defineMessages } from "react-intl";

const baseId = "t.pages.Admin.NotifyManagement.";

export default defineMessages({
  CTABack: {
    id: baseId + "CTABack",
    defaultMessage: "Back",
  },
  panelTitle: {
    id: baseId + "panelTitle",
    defaultMessage: "TITLE",
  },
  emptyTable: {
    id: baseId + "emptyTable",
    defaultMessage: "no elements",
  },
});
